export function loadViewAs() {
  //TODO: add consts for local/session storage keynames
  const data = localStorage.getItem('view-as');
  return data;
}
